import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from "react-query";
import { createReminder } from "@/services/tasks";
import { useSelectedPatientStore } from "@/stores/selected-patient";

/** Mutation hook for creating a new patient reminder. Appends the new reminder to the local store on success. */
export function useCreateReminder(patientUid) {
  return useMutation(function (payload) {
    if (!patientUid) throw new Error("patientUid is required");
    return createReminder(String(patientUid), payload);
  }, {
    onSuccess: function onSuccess(createdReminder) {
      var _selectedPatient$remi;
      var _useSelectedPatientSt = useSelectedPatientStore.getState(),
        selectedPatient = _useSelectedPatientSt.selectedPatient,
        setSelectedPatient = _useSelectedPatientSt.setSelectedPatient;
      if (!selectedPatient) return;
      setSelectedPatient(_objectSpread(_objectSpread({}, selectedPatient), {}, {
        reminders: [].concat(_toConsumableArray((_selectedPatient$remi = selectedPatient.reminders) !== null && _selectedPatient$remi !== void 0 ? _selectedPatient$remi : []), [createdReminder])
      }));
    }
  });
}